import React from 'react';


import {EditSearchColumns} from 'src/components/edit-columns';
import {withPlatformColumnOptions} from 'src/components/user-platform-column/platform-column-options';
import {usePlatformColumn} from 'src/components/user-platform-column/use-platform-column';
import {useProductColumnOptions} from 'src/components/user-product-columns/use-product-column-options';
import {STATSIG_GATES} from 'src/contexts/statsig-contex';
import {SearchType} from 'src/openapi/admin/models/SearchType';

import {useGateValue} from '@pb/kit-lib-statsig';

import {
    ALL_OPTIONS,
    COLUMNS, ITEMS,
    LIMITED_SORT_COLUMNS, NO_SORT_COLUMNS,
    OPTIONS_SETTINGS,
    OPTION_GROUPS,
    SORING_LABElS,
    USER_SEARCH_COLUMNS,
} from '../constants';

import type {UserSearchTemplate} from 'src/openapi/admin/models/UserSearchTemplate';

type Props = {
    place: string,
    adminId: number,
    isLoading: boolean,
    templates: UserSearchTemplate[],
    activeSearchTemplate: UserSearchTemplate,
    setActiveSearchTemplate: (actionProps: UserSearchTemplate) => Promise<string | null>,
    loadTemplates: () => void,
    loadActiveSearchTemplate: () => Promise<void>,
};

export const UserSearchEditColumns = (props: Props) => {
    const {enabled, columnAdapter} = usePlatformColumn();
    const bdcFeatureAvailable = useGateValue(STATSIG_GATES.BDC_DOWNLOAD_MONTHLY_FEATURE);
    const cloFeatureAvailable = useGateValue(STATSIG_GATES.CLO_LIMIT_FEATURE);
    const cloTradeFeatureAvailable = useGateValue(STATSIG_GATES.CLO_TRADE_LIMIT_FEATURE);

    const updatedItems = ITEMS.map(item => {
        if (!item.items) {
            return item;
        }

        const updatedOptions = item.items.map(optionGroup => {
            const options = optionGroup.options.map(option => {
                if (!('option' in option)) {
                    return option;
                }
                if (!bdcFeatureAvailable && option.option.label.startsWith('BDC Portfolio And Universe')) {
                    return {...option, hidden: true};
                }
                if (!cloFeatureAvailable && option.option.label.startsWith('CLO Portfolio Holdings Universe')) {
                    return {...option, hidden: true};
                }
                if (!cloTradeFeatureAvailable && option.option.label.startsWith('CLO Trade Data Universe')) {
                    return {...option, hidden: true};
                }
                return option;
            });
            return {...optionGroup, options};
        });
        return {...item, items: updatedOptions};
    });

    const productOptions = withPlatformColumnOptions(useProductColumnOptions({
        columns: COLUMNS, columnsMap: USER_SEARCH_COLUMNS, items: updatedItems,
        allOptions: ALL_OPTIONS, optionGroups: OPTION_GROUPS, noSortColumns: NO_SORT_COLUMNS,
    }), enabled);

    return (
        <EditSearchColumns
            key={String(enabled)}
            columnAdapter={columnAdapter}
            place={props.place}
            userId={props.adminId}
            searchType={SearchType.USER}
            isLoading={props.isLoading}
            templates={props.templates}
            activeTemplate={props.activeSearchTemplate}
            columns={productOptions.columns}
            sortingDataMap={SORING_LABElS}
            limitedSortColumns={LIMITED_SORT_COLUMNS}
            noSortColumns={productOptions.noSortColumns}
            columnsMap={productOptions.columnsMap}
            items={productOptions.items}
            allOptions={productOptions.allOptions}
            optionGroups={productOptions.optionGroups}
            optionSettings={OPTIONS_SETTINGS}
            onSetActiveTemplate={props.setActiveSearchTemplate}
            onUpdateTemplates={props.loadTemplates}
            onUpdateColumns={() => {
                props.loadActiveSearchTemplate();
                props.loadTemplates();
            }}
        />
    );
};
